import Choices from 'choices.js';
var CustomSelect = /** @class */ (function () {
    function CustomSelect() {
        var _this = this;
        this.customSelectElements = document.querySelectorAll('.js-select');
        this.gformSelectElements = document.querySelectorAll('.gfield_select');
        this.gformFieldsetSelectElements = document.querySelectorAll('fieldset.gfield select');
        window.addEventListener('load', function () { return _this.init(); });
    }
    CustomSelect.prototype.init = function () {
        if (this.gformFieldsetSelectElements.length > 0) {
            this.initGformFieldsetSelect();
        }
        if (this.gformSelectElements.length > 0) {
            this.initGformSelect();
        }
        if (this.customSelectElements.length > 0) {
            this.initCustomSelect();
        }
    };
    CustomSelect.prototype.initGformFieldsetSelect = function () {
        this.gformFieldsetSelectElements.forEach(function (select) {
            var choices = new Choices(select, {
                silent: false,
                searchEnabled: false,
                searchChoices: false,
                placeholder: true,
                itemSelectText: '',
            });
            choices.passedElement.element.addEventListener('choice', function (event) {
                var selectLabel = event.currentTarget.parentElement.parentElement.parentElement.querySelector('label');
                if (selectLabel) {
                    selectLabel.classList.add('active');
                }
            }, false);
        });
    };
    CustomSelect.prototype.initGformSelect = function () {
        this.gformSelectElements.forEach(function (select) {
            var choices = new Choices(select, {
                silent: false,
                searchEnabled: false,
                searchChoices: false,
                placeholder: true,
                itemSelectText: '',
            });
            choices.passedElement.element.addEventListener('choice', function (event) {
                var selectLabel = event.currentTarget.parentElement.parentElement.parentElement.parentElement.querySelector('label');
                if (selectLabel) {
                    selectLabel.classList.add('active');
                }
            }, false);
        });
    };
    CustomSelect.prototype.initCustomSelect = function () {
        window.choicesJsElements = {}; // Global object for storing Choices.js elements
        this.customSelectElements.forEach(function (select) {
            select.parentElement.classList.add('choices-selector');
            var choices = new Choices(select, {
                silent: false,
                searchEnabled: false,
                searchChoices: false,
                placeholder: true,
                itemSelectText: '',
            });
            // If select needs to be global - accessible from other scripts
            if (("globalSelect" in select.dataset)) {
                // Push to global window object
                window.choicesJsElements[select.dataset.globalSelect] = choices;
            }
        });
    };
    return CustomSelect;
}());
export default CustomSelect;
